export interface HudState {
  backend: string;
  tier: string;
  fps: number;
  resolution: string;
  ping: string;
  build: string;
  error?: string;
}

/** Minimal debug HUD. The real HUD (HP, stamina, Surge, cooldowns) is React-based from M1. */
export function createHud(el: HTMLElement) {
  let last = '';
  return {
    render(s: HudState) {
      const html = `<dl>
        <dt>renderer</dt><dd>${s.backend}</dd>
        <dt>quality</dt><dd>${s.tier}</dd>
        <dt>fps</dt><dd>${s.fps.toFixed(0)}</dd>
        <dt>resolution</dt><dd>${s.resolution}</dd>
        <dt>server</dt><dd>${s.ping}</dd>
        <dt>build</dt><dd>${s.build}</dd>
      </dl>${s.error ? `<div class="error">${escapeHtml(s.error)}</div>` : ''}`;
      if (html !== last) {
        el.innerHTML = html;
        last = html;
      }
    },
  };
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (ch) => `&#${ch.charCodeAt(0)};`);
}
